import React from 'react';
import { useTranslation } from 'react-i18next';

interface VarCardProps {
  name: string;
  type: string;
  example: string;
  children: React.ReactNode;
}

// Shared by the TouchPose, Squarebit Eye and Squarebit Subdivs docs. `name`,
// `type` and `example` are literal values (a parameter name, its type, a
// default) and are never translated — but the "e.g." lead-in is prose, so it
// is keyed. The "#" stays literal: it is the comment marker, not a word.
const VarCard: React.FC<VarCardProps> = ({ name, type, example, children }) => {
  const { t } = useTranslation();
  return (
  <div className="border border-surface-hover rounded-[8px] px-[16px] py-[14px] my-[12px] bg-surface">
    <div className="flex items-baseline gap-[10px] mb-[6px] flex-wrap">
      <code className="font-mono text-[14px] font-bold text-blue-link break-words min-w-0">
        {name}
      </code>
      <span className="text-[12px] text-slate-500 bg-surface-secondary border border-border rounded-[4px] px-[7px] py-[1px]">
        {type}
      </span>
      <code className="font-mono text-[11px] text-slate-400">
        # {t('common.eg')} {example}
      </code>
    </div>
    <div className="text-[13px] text-content-secondary leading-[1.6]">
      {children}
    </div>
  </div>
  );
};

export default VarCard;
